export default () => ({
    recordReactions: []
});

   
